import { useEffect } from 'react'

import { useDebounceFunc } from '../../../../../hooks'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

import { ACTIVITIES_AUTOMATION_RELOAD_TIMEOUT } from './useRequestProfileTabActivitiesReload.constants'

export function useRequestProfileTabActivitiesReload({ requestId, onReload }) {
  const { handleLoadCounters, handleReloadOpenActivities } =
    useRequestProfileContext()

  async function handleReloadAll() {
    handleReloadOpenActivities?.()
    handleLoadCounters?.()

    return onReload()
  }

  // Pipeline automations finish on the backend after the activity update
  // responds, so callers reload once more after a delay; the timer is tab-level
  // because the phase table that triggered it may auto-collapse and unmount.
  const { cancelDebounce, debouncedHandler: handleReloadAllDelayed } =
    useDebounceFunc(handleReloadAll, ACTIVITIES_AUTOMATION_RELOAD_TIMEOUT)

  useEffect(
    () => () => {
      cancelDebounce()
    },
    [requestId]
  )

  return { handleReloadAll, handleReloadAllDelayed }
}
